import { Injectable } from '@angular/core';
import { HttpFunctionsService } from '../http-services/http-functions.service';
import { catchError, map } from 'rxjs/operators';
import { throwError, Observable, forkJoin } from 'rxjs'
import { CouponListModel } from 'src/app/models/coupon-list';
import  moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class CouponService {
  couponUrl: string = 'coupon/';
  constructor(
    private httpService: HttpFunctionsService) { }

    getCouponList(data:any, isShowPagination: boolean = true): Observable<Array<CouponListModel>> {
      return this.httpService.postMethod(this.couponUrl+`list`,data, isShowPagination).pipe(map( (couponRes: any) => {
        let couponList: Array<CouponListModel> = [];
        if (couponRes.data && couponRes.data.length > 0) {
          couponRes.data.forEach((element: any) => {
            element.isExpired = moment(element.expire_at).isBefore(moment());
            couponList.push(element);
          });
        }
        return couponList;
      }),catchError((error) => {
        return throwError(error);
      }));
    }

    couponInsert(data:any) {
      return this.httpService.postMethod(this.couponUrl+'insert',data);
    }

    updateCoupon(data:any,couponId:string) {
      return this.httpService.putMethod(this.couponUrl+`${couponId}/update`,data);
    }

    deleteCoupon(couponId:any) {
      return this.httpService.deleteMethod(this.couponUrl+`${couponId}/delete`);
    }

  applyCoupon(data: any): Observable<CouponListModel> {
    // Determine which arrays have content
    const hasSoundsContent = data.sounds && Array.isArray(data.sounds) && data.sounds.length > 0;
    const hasBeatsContent = data.beats && Array.isArray(data.beats) && data.beats.length > 0;

    // For 'both' coupons with both arrays, call BOTH APIs simultaneously
    if (hasSoundsContent && hasBeatsContent) {
      const beatData = {
        coupon_id: data.coupon_id,
        beats: data.beats
      };
      const soundData = {
        coupon_id: data.coupon_id,
        sounds: data.sounds
      };

      // Call both APIs in parallel using forkJoin
      return forkJoin({
        beatResponse: this.httpService.putMethod('beat-coupon/upsert', beatData),
        soundResponse: this.httpService.putMethod('sound-coupon/upsert', soundData)
      }).pipe(
        map((responses: any) => {
          // Merge the responses - combine beats and sounds from both responses
          let couponData: any = null;

          if (responses.beatResponse?.data?.[0]) {
            couponData = responses.beatResponse.data[0];
          } else if (responses.soundResponse?.data?.[0]) {
            couponData = responses.soundResponse.data[0];
          }

          // Add both beats and sounds arrays to the final response
          if (couponData) {
            couponData.beats = responses.beatResponse?.data?.[0]?.beats || [];
            couponData.sounds = responses.soundResponse?.data?.[0]?.sounds || [];
            couponData.isExpired = moment(couponData.expire_at).isBefore(moment());
          }

          return couponData;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
    }
    // For single content type, use the appropriate endpoint
    else {
      let endpoint: string;
      if (hasSoundsContent) {
        // Enrolling sounds only
        endpoint = 'sound-coupon/upsert';
      } else if (hasBeatsContent) {
        // Enrolling beats only
        endpoint = 'beat-coupon/upsert';
      } else {
        // Disenrollment (empty arrays) - check which property exists
        const hasSoundsProperty = data.hasOwnProperty('sounds');
        endpoint = hasSoundsProperty ? 'sound-coupon/upsert' : 'beat-coupon/upsert';
      }

    return this.httpService.putMethod(endpoint, data).pipe(map((couponRes: any) => {
      let couponList: Array<CouponListModel> = [];
      if (couponRes.data && couponRes.data.length > 0) {
        couponRes.data.forEach((element: any) => {
          element.isExpired = moment(element.expire_at).isBefore(moment());
          couponList.push(element);
        });
      }
      return couponList[0];
      }),catchError((error) => {
        return throwError(error);
      }));;
    }
  }


  uploadBeatandSoundKitListApplyCoupon(data:any) {
    const body = {
      select: {
        beats: true,
        sounds: true
      },
      page: {
        offset: 0,
        limit: 100
      }
    }
    this.getCouponList(body, true).pipe(map( (couponRes: any) => {
        let couponList: Array<CouponListModel> = [];
        if (couponRes.data && couponRes.data.length > 0) {
          couponRes.data.forEach((element: any) => {
            element.isExpired = moment(element.expire_at).isBefore(moment());
            couponList.push(element);
          });
        }
        return couponList;
      }),catchError((error) => {
        return throwError(error);
    }));
  }


}
